module.exports = __webpack_public_path__ + "img/jam-meta-image.png";